import { CalendarMultipleCheckIcon } from './CalendarMultipleCheckIcon';

/**
 * author: Austin Andrews
 * id 7329D294-805D-4843-AB03-B87C661C296A
 * name calendar-multiple-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-multiple-check.svg
 * tags
 * - Date / Time 
 */
export const EventMultipleCheckIcon = CalendarMultipleCheckIcon;
export default EventMultipleCheckIcon